<template>
  <v-dialog v-model="data.useDialog" :persistent="data.persistent" :width="data.getWidth">
    <div class="dialogCon">
      <div v-html="data.messageHTML"></div>
      <div class="btn">
        <div v-if="data.getBtnCount === 2">
          <v-btn
            class="UXbtn"
            large
            :outline="!data.useReverse"
            :dark="data.useReverse"
            :color="data.useReverse ? '#CF1322' : ''"
            round
            @click="
              data.getLeftBtnEvent();
              closePopup();
            "
            >{{ data.getLeftBtnName }}
          </v-btn>
          <v-btn
            v-if="!data.isLoading && data.getBtnName"
            class="UXbtn"
            :outline="data.useReverse"
            :dark="!data.useReverse"
            :color="data.useReverse ? '' : '#5578F0'"
            large
            round
            @click="
              data.getButtonEvent();
              closePopup();
            "
            >{{ data.getBtnName }}
          </v-btn>
          <v-btn
            v-else-if="data.isLoading && data.getBtnName"
            :loading="data.dialog"
            class="UXbtn"
            color="#5578F0"
            dark
            large
            round
            @click="
              data.getButtonEvent();
              changeLoading();
            "
          >
            {{ data.getBtnName }}
          </v-btn>
        </div>
        <div v-else>
          <v-btn
            class="UXbtn"
            color="#5578F0"
            dark
            large
            round
            @click="
              data.getButtonEvent();
              closePopup();
            "
            >{{ data.getBtnName }}</v-btn
          >
        </div>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { replaceNewLine } from '@/util';
export default {
  name: 'DialogPopup',
  data() {
    return {
      data: {
        useDialog: false,
        persistent: true,
        getWidth: 400,
        messageHTML: '',
        getBtnCount: 1,
        getBtnName: '확인',
        getLeftBtnName: '취소',
        getButtonEvent: () => {},
        getLeftBtnEvent: () => {},
        isLoading: false,
        dialog: false,
        useReverse: false
      }
    };
  },
  mounted() {
    this.initialize();
  },
  methods: {
    initialize() {
      const defaultData = () => {
        return {
          useDialog: false,
          persistent: true,
          getWidth: 400,
          messageHTML: '',
          getBtnCount: 1,
          getBtnName: '확인',
          getLeftBtnName: '취소',
          isLoading: false,
          dialog: false,
          getButtonEvent: () => {},
          getLeftBtnEvent: () => {},
          useReverse: false
        };
      };
      this.data = defaultData();
      this.$eventBus.$on('DialogPopup', (val) => {
        try {
          if (!this.data.useDialog) {
            this.data.useDialog = val.useDialog || defaultData().useDialog;
            this.data.persistent = val.persistent || defaultData().persistent;
            this.data.getWidth = val.getWidth || defaultData().getWidth;
            this.data.messageHTML = replaceNewLine(val.messageHTML || defaultData().messageHTML);
            this.data.getBtnCount = val.getBtnCount || defaultData().getBtnCount;
            this.data.getBtnName = val.getBtnName || defaultData().getBtnName;
            this.data.getLeftBtnName = val.getLeftBtnName || defaultData().getLeftBtnName;
            this.data.isLoading = val.isLoading || defaultData().isLoading;
            this.data.getButtonEvent = val.getButtonEvent || defaultData().getButtonEvent;
            this.data.getLeftBtnEvent = val.getLeftBtnEvent || defaultData().getLeftBtnEvent;
            this.data.dialog = false;
            this.data.useReverse = val.useReverse || defaultData().useReverse;
          }
        } catch (e) {
          console.log(e);
        }
      });
      this.$eventBus.$on('ClosePopup', (val) => this.closePopup());
    },
    changeLoading() {
      this.data.dialog = true;
    },
    closePopup() {
      this.data.useDialog = false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/DialogPopup.vue